import { createGhostTheme as m } from "./highrise468.mjs";
import { createPrimaryTheme as n } from "./highrise469.mjs";
import { createSecondaryTheme as c } from "./highrise470.mjs";
import { createTertiaryTheme as i } from "./highrise471.mjs";
import { createTextTheme as y } from "./highrise472.mjs";
const s = {
  blue: "primary",
  red: "error",
  gray: "gray",
  orange: "warning",
  green: "success"
}, t = {
  primary: n,
  secondary: c,
  tertiary: i,
  ghost: m,
  text: y
};
function u(o = "blue", a = "primary") {
  const r = s[o], e = t[a];
  return !r || !e ? t.secondary("gray") : e(r);
}
export {
  u as createButtonVariantStyle
};
